    <div class = "admin-chat" *ngIf = "allResponseType![0] == 'network-error'">
      <p-image class=""
    src="{{properties!.chat_logo}}"
    alt="Image"
    width="250"></p-image>

        <bdi>
          <strong class = "font-style title-size" style = "color: #ef2d40;">Sorry, Some Issue Happened</strong>
          <p  class = "font-style caption-size">
              Please try again later.
          </p>
        </bdi>
    </div>

    <div class = "admin-chat " *ngIf = "allResponseType![0] == 'response-error'">
      <p-image class=""
    src="{{properties!.chat_logo}}"
    alt="Image"
    width="250"></p-image>
        <bdi>
          <strong  class = "font-style title-size">Sorry, I'm not sure I got that</strong>
          <div  class = "font-style caption-size">
              How may I help you today?
          </div>
        </bdi>
    </div>

    <div class = 'admin-chat' *ngFor="let responseInfo of allResponseInfoArray; let i = index"  >
      <p-image class="" *ngIf="i == 0" [ngClass]="[responseInfo[0]['expand']? 'expandHide' : '']"
          src="{{properties!.chat_logo}}"
          alt="Image"
          width="250"></p-image>
      
      <div class="admin-chat" [ngClass]="[responseInfo[0]['expand']? 'expandChatIndex' + expandIndex + i + ' expand-chat' : '']" *ngIf = 'allResponseType![i] == "chat-message"'>
        <div *ngIf = "i != 0" style = "width : 100%; max-width: 35px;"></div>
        <bdi class = "font-style chat-message" style = "position: relative;">
          <strong class = "title-size responseP" [innerHTML]="responseInfo[0]['title']"></strong>
          <div class = 'caption-size responseP' [innerHTML]=" responseInfo[0]['message']"></div>
          <button (click) = "copy(responseInfo[0]['message'])" [ngClass]="[copied ? 'pi pi-check': 'pi pi-copy']"  style="position: absolute; bottom: 0; right:0;"></button>
        </bdi>
      </div>

      <div class="admin-chat" [ngClass]="[responseInfo[0]['expand']? 'expandChatIndex' + expandIndex + i + ' expand-chat' : '']" style = "background-color: transparent;" *ngIf = 'allResponseType![i] == "help"'>
        <div *ngIf = "i != 0" style = "width : 35px"></div>
        <bdi class = "bdi-with-image">
          <button class= "button-with-image" (click)="onButtonClick(responseInfo[0]['ask-type'],responseInfo[0]['displaytext']) ">
              <p-image class = "inline" 
                  src="{{responseInfo[0]['help-icon-url']}}"
                  alt="Image"
                  width="250"
                  height = "250"
              ></p-image>
              <span class = "button-text font-style responseP" [innerHTML]="responseInfo[0]['displaytext']"></span>
          </button>
        </bdi>
      </div> 

      <div class="admin-chat" [ngClass]="[responseInfo[0]['expand']? 'expandChatIndex' + expandIndex + i + ' expand-chat' : '']" *ngIf = 'allResponseType![i] == "send-text"'>
        <div *ngIf = "i != 0" style = "width : 35px"></div>
        <bdi class = "bdi-with-image">
          <button class= "button-with-image" (click)="onButtonClick(responseInfo[0]['ask-type'], responseInfo[0]['displaytext'])">
            <p-image class = "inline" 
                  src="{{responseInfo[0]['text-icon-url']}}"
                  alt="Image"
                  width="250"
                  height = "250"></p-image>
            <span class = "button-text font-style responseP" [innerHTML]="responseInfo[0]['displaytext']"></span>
        
          </button>
        </bdi>
    </div>

    <div class="admin-chat" [ngClass]="[responseInfo[0]['expand']? 'expandChatIndex' + expandIndex + i + ' expand-chat' : '']" *ngIf = 'allResponseType![i] == "send-email"'>
      <div *ngIf = "i != 0" style = "width : 35px"></div>
      <bdi class = "bdi-with-image">
        <button class= "button-with-image" (click)="onButtonClick(responseInfo[0]['ask-type'], responseInfo[0]['displaytext'])">
          <p-image class = "inline" 
          src="{{responseInfo[0]['email-icon-url']}}"
          alt="Image"
          width="250"
          height = "250"></p-image>
          <span class = "button-text font-style responseP" [innerHTML]="responseInfo[0]['displaytext']"></span>

        </button>
      </bdi>
  </div>


  <div class="admin-chat" [ngClass]="[responseInfo[0]['expand']? 'expandChatIndex' + expandIndex + i + ' expand-chat' : '']" *ngIf = 'allResponseType![i] == "set-address"'>
    <div *ngIf = "i != 0" style = "width : 35px"></div>
    <bdi class = "bdi-with-image">
      <button class= "button-with-image" (click)="onButtonClick(responseInfo[0]['ask-type'], responseInfo[0]['displaytext'])">
        <p-image class = "inline"
        src="{{responseInfo[0]['help-icon-url']}}"
        alt="Image"
        [style]="{ 'width.px': '10', 'height.px': '10' }"></p-image>
        <span class = "button-text font-style responseP" [innerHTML]="responseInfo[0]['displaytext']"></span>
      </button>
    </bdi>
  </div>

  <div class="card flex align-items-center suggestion-box admin-chat" [ngClass]="[responseInfo[0]['expand']? 'expandChatIndex' + expandIndex + i + ' expand-chat' : '']" *ngIf = 'allResponseType![i] == "chip"'>
    <p-chip class = "p-chip"  *ngFor="let chip of responseInfo">
        <button class= "chip-with-image" (click)="onButtonClick(chip['ask-type'], chip['chip-message'])">            
            <span class = "chip-text font-style" [innerHTML]="chip['chip-message']"></span>

        </button>
    </p-chip>
  </div>

  <div class="admin-chat" [ngClass]="[responseInfo[0]['expand']? 'expandChatIndex' + expandIndex + i + ' expand-chat' : '']" [ngClass]="[responseInfo[0]['expand']? 'expandChatIndex' + expandIndex + i + ' expand-chat' : '']" *ngIf='allResponseType![i] == "list"'>
    <div *ngIf = "i != 0" style = "width : 35px"></div>
    <bdi class = "p-list"style = "background-color: transparent;">
      <div class="queries">
        <p-accordion class = "font-style chat-response " [activeIndex]="0">
          <p-accordionTab [ngClass]="{activated: ind == 0}" class="middle-list  font-style title-size" *ngFor="let content of responseInfo; let ind = index" [header]="content['list-action'] != 'title' ? content['list-title'] : '' ">
            
            <ng-template *ngIf = "content['list-action'] == 'title'"  pTemplate="header"class = "title-size">
              <span class="flex align-items-center gap-2 w-full s-chat">
                <p-image
                
                  src="{{properties!.chat_logo}}"
                  alt="Image"
                ></p-image>
                <span *ngIf = "content['list-action'] == 'title'" class="title">
                  {{content['list-title']}}</span>
              </span>
            </ng-template>

            
            <p class="caption-size" *ngIf = "content['list-action'] == 'title'" [innerHTML]="content['list-detail']"></p>

            <div class="caption-size" *ngIf="content['list-action'] == 'description'" [innerHTML]="content['list-detail']"></div>

            <div class = "caption-size " *ngIf="content['list-action'] == 'image'">
                <b [innerHTML]="content['list-detail']"></b>
                <p-image
                src="{{content['list-url']}}"
                alt="Image"
              ></p-image>
            </div>
        
            </p-accordionTab>

        </p-accordion>
      </div>
    </bdi>
  </div>

  <div class="admin-chat expand-chat "  [ngClass]="[responseInfo[0]['expand']? 'expandChatIndex' + expandIndex + i + ' expand-chat' : '']" *ngIf='allResponseType![i] == "image-card"'>
    <div class = "logo" *ngIf = "i != 0" style = "width : 35px"></div>
    <bdi class="not-chat image-container ">
      <div class="queries-card font-style">
        <b class = "title-size" [innerHTML]="responseInfo[0]['title']"></b>
        <p class = " caption-size" [innerHTML]="responseInfo[0]['message']"></p>
        <img class = "image-card" src="{{responseInfo[0]['image-url']}}" />
      </div>
    </bdi>
  </div>


  
  <div class="admin-chat expand-chat map-card index{{mapIndex}}" [ngClass]="[responseInfo[0]['expand'] ? 'expandChatIndex' + expandIndex + i + ' expand-chat' : '']" *ngIf='allResponseType![i] == "map-card"'>
    <bdi class="not-chat">
        <div class="queries-card font-style index{{mapIndex}}" >
          <b class = "title-size" [innerHTML]="responseInfo[0]['title']"></b>
          <div class="search-container index{{mapIndex}}" style = "content-visibility: hidden;">          
            <input class="controls pac-input-text index{{mapIndex}}" type="text" placeholder="Please Enter Your Address"/>
          </div>
          <div #map id="q11-chat-map" class = "map-view index{{mapIndex}}" style="width: 100% ;height:35vh"></div>
        </div>
    </bdi>
  </div>

  
<div class=" card flex align-items-center suggestion-box admin-chat help-buttons-list" [ngClass]="[responseInfo[0]['expand'] ? 'expandChatIndex' + expandIndex + i + ' expand-chat' + ' expand-chat' : '']" *ngIf = 'allResponseType![i] == "button-list"'>

  <p-chip class = "p-chip chip-buttons-list"  *ngFor="let but of responseInfo">
    <button  class= "button-with-image " (click)="onButtonClick(but['ask-type'], but['name'], but)">    
      <p-image class = "inline"
      src="{{but['button-url']}}"
      alt="Image"
      [style]="{ 'width.px': '10', 'height.px': '10', 'margin-left': '5px' }"
      ></p-image>   
      <span class = 'chip-button-text' [innerHTML]="but['name']">
      </span>

    </button>
  </p-chip>
</div>



  <!-- <div class="admin-chat help-buttons-list" *ngIf = 'allResponseType![i] == "button-list"'>
    <bdi class = 'not-chat bdi-with-image' style = "display: flex; flex-direction: row;">
      <span class = 'button-chip' *ngFor="let but of responseInfo">
        <button  class= "button-with-image" (click)="onButtonClick(but['ask-type'], but['name'])">       
          <p-image class = "inline"
        src="{{but['button-url']}}"
        alt="Image"></p-image>
          <span>
            {{but['name']}}
          </span>
        </button>
      </span>
    </bdi>
  </div> -->




</div>







